import Tooltip from './src/main';

/* istanbul ignore next */
Tooltip.install = function (Vue) {
  Vue.component(Tooltip.name, Tooltip);
};

export default Tooltip;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/element-ui/packages/tooltip/index.js